module.exports = __webpack_public_path__ + "img/qiandao.989b36e8.png";